export const FETCH_PART_NO_LIST_REQUEST = '@@toyota/FETCH_PART_NO_LIST_REQUEST';
export const FETCH_PART_NO_LIST_FAILED = '@@toyota/FETCH_PART_NO_LIST_FAILED';
export const FETCH_PART_NO_LIST_SUCCESS = '@@toyota/FETCH_PART_NO_LIST_SUCCESS';

export const FETCH_SPECIAL_PART_LIST_REQUEST = '@@toyota/FETCH_SPECIAL_PART_LIST_REQUEST';
export const FETCH_SPECIAL_PART_LIST_FAILED = '@@toyota/FETCH_SPECIAL_PART_LIST_FAILED';
export const FETCH_SPECIAL_PART_LIST_SUCCESS = '@@toyota/FETCH_SPECIAL_PART_LIST_SUCCESS';

export const CLEAR_SPECIAL_PART_LIST = '@@toyota/CLEAR_SPECIAL_PART_LIST';

export const DELETE_SPECIAL_PART_REQUEST = '@@toyota/DELETE_SPECIAL_PART_REQUEST';
export const DELETE_SPECIAL_PART_FAILED = '@@toyota/DELETE_SPECIAL_PART_FAILED';
export const DELETE_SPECIAL_PART_SUCCESS = '@@toyota/DELETE_SPECIAL_PART_SUCCESS';

export const FETCH_SPECIAL_PART_BY_CODE_REQUEST = '@@toyota/FETCH_SPECIAL_PART_BY_CODE_REQUEST';
export const FETCH_SPECIAL_PART_BY_CODE_FAILED = '@@toyota/FETCH_SPECIAL_PART_BY_CODE_FAILED';
export const FETCH_SPECIAL_PART_BY_CODE_SUCCES = '@@toyota/FETCH_SPECIAL_PART_BY_CODE_SUCCES';

export const EDIT_SPECIAL_PART_REQUEST = '@@toyota/EDIT_SPECIAL_PART_REQUEST';
export const EDIT_SPECIAL_PART_FAILED = '@@toyota/EDIT_SPECIAL_PART_FAILED';
export const EDIT_SPECIAL_PART_SUCCESS = '@@toyota/EDIT_SPECIAL_PART_SUCCESS';

export const SAVE_SPECIAL_PART_LIST_REQUEST = '@@toyota/SAVE_SPECIAL_PART_LIST_REQUEST';
export const SAVE_SPECIAL_PART_LIST_FAILED = '@@toyota/SAVE_SPECIAL_PART_LIST_FAILED';
export const SAVE_SPECIAL_PART_LIST_SUCCESS = '@@toyota/SAVE_SPECIAL_PART_LIST_SUCCESS';

export const CHANGE_SPECIAL_PART_INFORMATION_PAGE = '@@toyota/CHANGE_SPECIAL_PART_INFORMATION_PAGE';
export const CHANGE_SPECIAL_PART_INFORMATION_PAGE_SIZE = '@@toyota/CHANGE_SPECIAL_PART_INFORMATION_PAGE_SIZE';
